import React from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";

export const ActorDetailFormReadOnly = React.memo(({ translate, dataSource, tableName }) => {
    const { id, name, eoriNo, city, state, country, countryCode, streetName, postalCode } = dataSource
    return (
        <div className="formContainer">
            <Grid.Row>
                <Grid.Column>
                    <InputField
                        id={`name-${tableName}-${id}`}
                        type='text'
                        name="name"
                        value={name}
                        label="NAME"
                        clearInput={false}
                        className="field-bg"
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column style={{ minWidth: '420px' }}>
                    <InputField
                        id={`streetName-${tableName}-${id}`}
                        type='text'
                        name="streetName"
                        value={streetName}
                        label="ADDRESS"
                        clearInput={false}
                        className="field-bg"
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField
                        id={`postalCode-${tableName}-${id}`}
                        type='text'
                        name="postalCode"
                        value={postalCode}
                        label="ZIP"
                        clearInput={false}
                        className="field-bg"
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField
                        id={`city-${tableName}-${id}`}
                        name="city"
                        type='text'
                        value={city}
                        label="PLACE"
                        clearInput={false}
                        className="field-bg"
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column>
                    <DropDown
                        id={`country-${tableName}-${id}`}
                        label="COUNTRY"
                        name="country"
                        direction="left"
                        clearable
                        labelClass="text-none"
                        value={country}
                        text={countryCode}
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField
                        id={`eoriNo-${tableName}-${id}`}
                        name="eoriNo"
                        type='text'
                        value={eoriNo}
                        label="EORI"
                        clearInput={false}
                        className="field-bg"
                        isDisabled={true}
                    />
                </Grid.Column>
            </Grid.Row>
        </div>

    );
})

ActorDetailFormReadOnly.defaultProps = {
    translate: (value) => value
}